// extracted by mini-css-extract-plugin
export var boldText = "_55-4";
export var checkboxContainer = "_55-6";
export var closeIcon = "_55-i";
export var container = "_55-0";
export var drawer = "_55-8";
export var drawerContent = "_55-9";
export var extraSmallText = "_55-5";
export var fulfillmentGroupTable = "_55-e";
export var largeText = "_55-3";
export var loadingSpinnerContainer = "_55-j";
export var mediumText = "_55-2";
export var narrow = "_55-f";
export var notificationLink = "_55-l";
export var packageCheckIconContainer = "_55-7";
export var slideoutHeaderActions = "_55-g";
export var slideoutHeaderActionsShifted = "_55-h";
export var slideoutHeaderContainer = "_55-a";
export var slideoutModal = "_55-c";
export var stickyHeaderWrapper = "_55-b";
export var table = "_55-k";
export var tableContainer = "_55-d";
export var tertiaryText = "_55-1";